module.exports = __webpack_public_path__ + "img/hippopotamus.895af818.png";